class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if( this.closest('#main-cart-items').dataset.id == 'cart-drawer') {
        this.closest('.cart-item__js').classList.add('d-none');
        this.closest('.cart-item').querySelector('.cart-undo__js').classList.remove('d-none');
        this.removeWithTimer = setTimeout(() => {
          this.closest('cart-items').updateQuantity(this.dataset.index, 0);
        }, 3000);
      } else {
        this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      }

    });
    if( this.closest('#main-cart-items').dataset.id == 'cart-drawer') {
      this.closest('.cart-item').querySelector('.cart-undo__js').addEventListener('click',(event) => {
        event.preventDefault();
        this.closest('.cart-item').querySelector('.cart-item__js').classList.remove('d-none');
        this.closest('.cart-item').querySelector('.cart-undo__js').classList.add('d-none');
        clearTimeout(this.removeWithTimer);
      });
    }


  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class BestSellerAdd extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const parentDiv =  this.closest('[data-content="best-seller__js"]');
      let activeVid;
      if( parentDiv ) {
          if (parentDiv.querySelector("select")) {
              // new custom setting for add
              activeVid = parentDiv.querySelector("select ").value;
          } else {
              activeVid = parentDiv
                  .querySelector(".card-variants div.active")
                  .querySelector("a").dataset.variantId;
          }

          const cartItems = this.closest("cart-items");
          cartItems
              .querySelector("product-form")
              .querySelector('[name="id"]').value = activeVid;
          cartItems
              .querySelector("product-form")
              .querySelector('[type="submit"]')
              .click();

          //tracking code here
          this.gtmTracking(this);
      }
    });
  }
  gtmTracking(events = null , type = null) {
    if( events == null )
      return false;
    var gtmLayerPush = window.dataLayer || [];
    let currentVariantTitle = this.getMainProductVariant();
    let parentProductTitle = document.querySelector('.gtm_tracking')?.getAttribute('data-product');


    var parentContainer = this.closest('[data-content="best-seller__js"]');
    // var dynamicAttributes = events.getAttribute('data-events');
    var imageLists = parentContainer.querySelectorAll(
        ".thumb-product-card-images img"
    );

    let activeImage = "";
    if (imageLists.length > 1) {
        imageLists = parentContainer.querySelectorAll(
            ".thumb-product-card-images img:not(.d-none)"
        );
    }
    activeImage = imageLists?.[0];
    // let upsellType = events.getAttribute('data-upselltype');
    gtmLayerPush.push({
        event: events.dataset.event
            ? events.dataset.event
            : "Clicked - PDP Upsell",
        upsellType: events.dataset.upselltype
            ? events.dataset.upselltype
            : "No Upsell Type Found",
        parentProductTitle: parentProductTitle
            ? parentProductTitle
            : "No Parent Product Title",
        parentProductVariantTitle: currentVariantTitle
            ? currentVariantTitle
            : "No Parent Product Variant Title",
        upsellProductTitle: activeImage.dataset.producttitle,
        upsellProductVariantTitle: activeImage.dataset.varianttitle,
        upselldisplayedPrice: activeImage.dataset.vprice
            ? parseFloat(activeImage.dataset.vprice).toFixed(2)
            : "Issue getting saleprice",
        pagePath: window.location.pathname,
        pageTitle: document.title,
    });
  }

  getMainProductVariant() {
    let mainButton = document.querySelector('#add-to-cart-main-button');
    let form = mainButton.closest('form');
    let mainVariantID = form.querySelector('[name="id"]');
    return this.getVariantTitleByID(mainVariantID.value);
  }

  getVariantTitleByID(vid) {
    let variant = document.querySelector(`#total-variant__js li[data-vid="${vid}"]`);
    return variant.dataset.vtitle;
  }

}

customElements.define('best-seller-add', BestSellerAdd);

class PlayboxAdd extends HTMLElement {
  constructor() {
    super();
    this.oldEstimatedTotal;
    this.oldSubtotal;
    this.oldHtml;

    this.summaryRecommended();
    this.addEventListener('change',(e)=>{
      // e.preventDefault();
      // this.debouncedOnChange.bind(this)
      this.swatchChanges(e);

    });
    this.addEventListener('click', (e) => {
      this.addCart(e);
    });
  }
  addCart(e) {
    var parentCard, index;
    if (!e.isTrusted) {
      e.target.classList.toggle('checked');
        parentCard = e.target.closest('playbox-add-check');
        index = e.target.getAttribute('data-index');
    } else {
        e.target.parentNode.classList.toggle('checked');
        parentCard = e.target.closest('playbox-add-check');
        index = e.target.parentNode.getAttribute('data-index');
    }
    let removeWhenChange = true;
    this.playHiddenUpdate(e,parentCard,index,removeWhenChange);
  }
  swatchChanges(e) {
    var parentCard, index;
    if (!e.isTrusted) {
      // e.target.classList.toggle('checked');
        parentCard = e.target.closest('playbox-add-check');
        index = e.target.getAttribute('data-index');
    } else {
        // e.target.parentNode.classList.toggle('checked');
        parentCard = e.target.closest('playbox-add-check');
        index = e.target.parentNode.getAttribute('data-index');
    }
    if (e.target.parentNode.classList.contains('checked') || e.target.classList.contains('checked')) {
      this.updatePlayboxPrice(this.oldHtml, 'minus',true);
    }

    let removeWhenChange = false;
    this.playHiddenUpdate(e,parentCard,index,removeWhenChange);

  }

  playHiddenUpdate(e,parentCard,index,removeWhenChange) {

    if (e.target.parentNode.classList.contains('checked') || e.target.classList.contains('checked')) {
      let activeVariant = parentCard.getAttribute('data-variant-id');
      let activeVariantDropdown = parentCard.querySelector('card-variant-customize select');
      let variantId = activeVariant;

      if (activeVariant) {

          // this.createInputData(index, variantId, null);
          // this.updatePlayboxPrice(parentCard, 'plus');
      } else if (activeVariantDropdown) {
          let selectIndex = activeVariantDropdown.options[activeVariantDropdown.selectedIndex];
          variantId = selectIndex.dataset.variantId;

      }
      this.createInputData(index, variantId, null);
      this.updatePlayboxPrice(parentCard, 'plus');
    } else {
        this.deleteInputField(index);
        if( removeWhenChange )
          this.updatePlayboxPrice(parentCard, 'minus');
    }
  }

  updatePlayboxPrice = (e,type,directPrice=false) => {
    let elementDiv = e.target;
    if( e.target == undefined ) {
      elementDiv = e;
    }
    if( directPrice ) {
      var clickedEstimated = this.oldEstimatedTotal.replace("$", "").trim();
      var clickedSubtotal = this.oldSubtotal.replace("$", "").trim();
    } else {
      var clickedEstimated = elementDiv.getAttribute('data-regularprice').replace("$", "").trim();
      var clickedSubtotal = elementDiv.getAttribute('data-saleprice').replace("$", "").trim();
    }

    let cartTotalPriceElm = document.querySelector('.cart__subtotal');
    let parentTotalDiv = cartTotalPriceElm.closest('.cart_total_price');

    let currCartEstimateTotal = cartTotalPriceElm.getAttribute('data-estimatedtotal');
    let currCartSubtotal = cartTotalPriceElm.getAttribute('data-cartsubtotal');

    if (type == 'plus') {
      var totalCartEstimateTotal = parseInt(currCartEstimateTotal) + parseInt(clickedEstimated);
      var totalCartSubtotal = parseInt(currCartSubtotal) + parseInt(clickedSubtotal);

    }
    if (type == 'minus') {
        var totalCartEstimateTotal = parseInt(currCartEstimateTotal) - parseInt(clickedEstimated);
        var totalCartSubtotal = parseInt(currCartSubtotal) - parseInt(clickedSubtotal);
    }
    cartTotalPriceElm.setAttribute('data-estimatedtotal', totalCartEstimateTotal);
    cartTotalPriceElm.setAttribute('data-cartsubtotal', totalCartSubtotal);

    // condition for the price difference checking
    let strikeHtml = ``;
    let totalPriceElm = parentTotalDiv.querySelector('.cart__total');
    if( totalPriceElm )
      parentTotalDiv.querySelector('.cart__total').remove();
    if( totalCartEstimateTotal != totalCartSubtotal) {
      strikeHtml += `<s>$${totalCartEstimateTotal}</s>`;
      let redHtml = `<span class="cart__total text-chilli-red ">$${totalCartSubtotal}</span>`;
      parentTotalDiv.insertAdjacentHTML("beforeend",redHtml);
    } else {
      strikeHtml += `$${totalCartEstimateTotal}`;
    }
    cartTotalPriceElm.innerHTML = strikeHtml;
    document
      .querySelector("#main-cart-footer")
      .querySelector(".cart_total_price").innerHTML = document
      .querySelector("#main-cart-footer-proxy")
      .querySelector(".cart_total_price").innerHTML;

    // let actualPriceElm = document.querySelector('.cart__subtotal');

    // let pdpPriceElm = document.querySelector('[data-price="price__js"] .price');

    // cartsubtotal = discount pachi ko totalPrice
    // estimatedtotal = actual price


  }
  createInputData( num,value,qty ) {
    let extraPrice = document.getElementById('product-extra-prices');
    let fieldAlreadyAdded = extraPrice.querySelector(`[name="items[${num}]id"]`);
    let fieldQty = extraPrice.querySelector(`[name="items[${num}]quantity"]`);
    if( !fieldAlreadyAdded ) {
        var x = document.createElement("INPUT");
        x.setAttribute("type", "hidden");
        x.setAttribute("name", `items[${num}]id`);
        x.setAttribute("value", value);
        // return x;
        extraPrice.appendChild(x);
    }
    if( !fieldQty && qty != null ) {
        var x = document.createElement("INPUT");
        x.setAttribute("type", "hidden");
        x.setAttribute("name", `items[${num}]quantity`);
        x.setAttribute("value", qty);
        extraPrice.appendChild(x);
    }
  }

  deleteInputField( num ) {
      let extraPrice = document.getElementById('product-extra-prices');
      let fieldAlreadyAdded = extraPrice.querySelector(`[name="items[${num}]id"]`);
      let fieldQty = extraPrice.querySelector(`[name="items[${num}]quantity"]`);
      if( fieldAlreadyAdded ) {
          fieldAlreadyAdded.remove();
      }
      if( fieldQty ) {
          fieldQty.remove();
      }
  }

  summaryRecommended() {
    var colorSwatches = document.querySelectorAll('.thumb-product-card__js .color-swatches a');
    var dropdownVariant = document.querySelectorAll('.thumb-product-card__js select');
    colorSwatches.forEach((swatch) => {
      swatch.addEventListener('click', (event) => {
        const currentTarget = event.currentTarget,
        clickedVariantId = currentTarget.getAttribute('data-variant-id'),
        clickedVariantAvailability = currentTarget.dataset.availability,
        parentDiv = currentTarget.closest('.thumb-product-card__js'),
        swatchesList = parentDiv.querySelectorAll('.swatch'),
        varitantImages = parentDiv.querySelectorAll('.thumb-product-card-images img'),
        salePrice = currentTarget.dataset.price,
        regularPrice = currentTarget.dataset.regularPrice;

        swatchesList.forEach((item) => {
            item.classList.remove("active");
        });
        if (clickedVariantAvailability == 'false'){
            currentTarget.closest('.thumb-product-card__js').querySelector('.pdp_pww__checker i').classList.add('d-none');
        }else{
            currentTarget.closest('.thumb-product-card__js').querySelector('.pdp_pww__checker i').classList.remove('d-none');
        }
        if (regularPrice){
            parentDiv.querySelector('.price-item--sale').classList.add('text-chilli-red');
        } else{
            parentDiv.querySelector('.price-item--sale').classList.remove('text-chilli-red');
        }

        this.oldHtml = parentDiv.querySelector('.summary__checker');
        this.oldEstimatedTotal = parentDiv.querySelector('.summary__checker').dataset.regularprice;
        this.oldSubtotal = parentDiv.querySelector('.summary__checker').dataset.saleprice;

        parentDiv.querySelector('.price-item--sale').innerHTML = salePrice;
        if(parentDiv.querySelector('.price__sale .text-link s') != null)
         parentDiv.querySelector('.price__sale .text-link s').innerHTML = regularPrice;
        parentDiv.querySelector('.summary__checker').dataset.regularprice = regularPrice;
        parentDiv.querySelector('.summary__checker').dataset.saleprice = salePrice;
        parentDiv.querySelector('.summary__checker').setAttribute("data-variant-id", clickedVariantId);



        currentTarget.parentNode.classList.add("active");
        varitantImages.forEach((image) => {
            const imageVariantId = image.getAttribute('data-variant-id');
            if (clickedVariantId === imageVariantId) {
                image.classList.add('show');
                image.classList.remove('d-none');
            } else {
                image.classList.add('d-none');
            }
        })

        // Assuming parentDiv is defined and contains the elements you're working with
        const pdpBlock = parentDiv.closest('.pdp_pww_block');
        const vIdInput = pdpBlock.querySelector('playbox-add-check');

        if (vIdInput) {
          const variantId = currentTarget.getAttribute('data-variant-id');

          // Update the value of the input field
          vIdInput.value = variantId;

          // Dispatch a 'change' event on the input field
          const changeEvent = new Event('change', {
            bubbles: true, // Ensure the event bubbles up the DOM tree
            cancelable: true, // Allow the event to be canceled if needed
          });
          vIdInput.dispatchEvent(changeEvent);
        } else {
          console.error('Input field not found.');
        }


      });
    });

    dropdownVariant.forEach((ddoption) => {
        ddoption.addEventListener('change', function(e){
            const currentTarget = e.currentTarget;
            const parentDiv = currentTarget.closest('.thumb-product-card__js');

            parentDiv.querySelector('.summary__checker').setAttribute("data-variant-id", e.target.value);
            parentDiv.querySelector('.summary__checker').setAttribute("data-saleprice", e.target.getAttribute("data-price"));
            parentDiv.querySelector('.price-item--sale').innerHTML = e.target.getAttribute("data-price");
        });
    });
  }
}

customElements.define('playbox-add-check', PlayboxAdd);



class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      if (!event.target.classList.contains("select__select")) {
        // your code
        this.onChange(event);
      } else {
        this.bestSellerSwatchesChange(event);
      }
    }, 300);
    if (document.querySelector(".cart-wrapper__js") != null) {
      this.querySelector("#cart-wrapper__js").addEventListener(
        "change",
        this.debouncedOnChange.bind(this)
      );
    } else {
      this.addEventListener("change", this.debouncedOnChange.bind(this));
    }
    // this.querySelector('#promoCode').removeEventListener('change', this.debouncedOnChange.bind(this));

    this.quantityInputs = this.querySelectorAll("quantity-input");
    this.CartSpecialInstructions = document.getElementById(
      "CartSpecialInstructions"
    );
    // Array.from(this.quantityInputs).forEach(element => {
    //   element.addEventListener('change',this.debouncedOnChange.bind(this))
    // });

    /**
     * Note settings
     */
    this.addNote();
    this.noteEvents();
    this.updateNotes();
    this.cartNoteCharacterCount();

    /**
     * Playbox Note Events
     *
     */
    this.playBoxSaveNote();
    this.playBoxCloseNote();
    this.playBoxAddNote();
    /**
     * Promo Code
     */
    this.promoClick();
    /**
     * Best Seller Slider
     */
    this.bestSellerSlider();
    this.setBestSellersPriority();
    this.showBestSellers();
  }
  playBoxSaveNote() {
    this.playBoxAddNoteButton = document.querySelector("#addNodeBtn");
    this.playBoxSaveNoteButton = document.querySelector("#js-cartFooterNoteSave");
    this.playBoxNotePrint = document.querySelector("#js-cartFooterNote");
    if(this.playBoxSaveNoteButton) {
      this.playBoxSaveNoteButton.addEventListener('click', ()=>{
        this.playBoxNotePrint.innerText = document.getElementById("CartSpecialInstructions").value;
        if (document.getElementById("CartSpecialInstructions").value.length > 0) {
          this.playBoxAddNoteButton.innerText = "Edit Note";
        } else {
          this.playBoxAddNoteButton.innerText = "Add Note";
        }
        this.noteClosed();
      })
    }
  }
  playBoxCloseNote() {
    this.playBoxAddNoteButton = document.querySelector("#addNodeBtn");
    this.playBoxCancelNote = document.querySelector(".close_note");
    this.playBoxNotePrint = document.querySelector("#js-cartFooterNote");
    if(this.playBoxCancelNote) {
      this.playBoxCancelNote.addEventListener('click', ()=>{
        document.getElementById("CartSpecialInstructions").value = this.playBoxNotePrint.innerHTML.replace(/<br>/g, "\n").trim();
        this.playBoxSaveNoteButton = document.querySelector("#js-cartFooterNoteSave");
        if (document.getElementById("CartSpecialInstructions").value.length > 0) {
          this.playBoxAddNoteButton.innerText = "Edit Note";
        } else {
          this.playBoxAddNoteButton.innerText = "Add Note";
        }
        this.noteClosed();
      })
    }
  }
  playBoxAddNote() {
    this.playboxNoteSubmit = document.querySelector('#playBoxCheckout');
    if(this.playboxNoteSubmit) {
      this.playboxNoteSubmit.addEventListener("click", () => {
        this.addNoteWithAddons();
      });
    }
  }
  addNoteWithAddons() {
    if (document.getElementById("CartSpecialInstructions")) {
        var giftMessage = document.getElementById(
            "CartSpecialInstructions"
        ).value;

        var addonProducts = document.querySelectorAll(
            "#product-extra-prices input"
        );

        var cartObj = {};
        let noteAttributes = {
            isGift: false,
        };
        cartObj["attributes"] = noteAttributes;
        // cartObj["note"] = giftMessage;
        var products = [];
        if (addonProducts.length > 0) {
            addonProducts.forEach((product) => {
                var pArray = {
                    id: product.value,
                    quantity: 1,
                };
                products.push(pArray);
            });
            cartObj["items"] = products;
        }

        var cartUrl = "/cart/update.js";
        if (addonProducts.length > 0) {
            cartUrl = `${routes.cart_add_url}`;
        }

        setTimeout(() => {
            fetch(`${cartUrl}`, {
                ...fetchConfig(),
                body: JSON.stringify(cartObj),
            })
                .then((response) => {
                    return response.text();
                })
                .then((state) => {
                    window.location.href = "/checkout";
                });
        }, 1000);
    }
  }
  bestSellerSlider() {
    const cartItems = document.querySelector("cart-items");
    if (cartItems.querySelectorAll(".card--recommended").length > 1) {
      new Swiper(".inline_recommendation_js", {
        loop: false,
        // autoHeight: true,
        allowTouchMove: true,
        spaceBetween: 10,
        slidesPerView: 1.25,
        pagination: {
          el: ".swiper-pagination-sm",
          clickable: true,
        },
      });
    }
  }
  setBestSellersPriority() {
    var $wrapper = $("#inlineCartRecommendation");
    $wrapper
      .find(".card")
      .sort(function (a, b) {
        return +a.dataset.priority - +b.dataset.priority;
      })
      .appendTo($wrapper);
  }
  showBestSellers() {
    if (document.getElementById("inlineCartRecommendation")) {
      var htmlstring = document.getElementById(
        "inlineCartRecommendation"
      ).innerHTML;
      htmlstring = htmlstring.trim
        ? htmlstring.trim()
        : htmlstring.replace(/^\s+/, "");
      if (htmlstring != "") {
        document
          .querySelector(".cart-recommendation--title-js")
          .classList.remove("d-none");
        document.querySelector("main").classList.add("has-you-may-like");
      } else {
        document
          .querySelector(".cart-recommendation--title-js")
          .classList.add("d-none");
        document.querySelector("main").classList.add("has-you-may-like");
      }
    }
  }
  promoClick() {
    let promoDiv = document.getElementById("promoCode");
    if (promoDiv) {
      promoDiv
        .querySelector(".add_promo__click")
        .addEventListener("click", (e) => {
          e.target.classList.toggle("d-none");
          promoDiv
            .querySelector(".promo-input__form")
            .classList.toggle("d-none");
        });
    }
  }

  addNote() {
    if (document.getElementById("note-checker")) {
      document.getElementById("note-checker").addEventListener("click", (e) => {
        var cartObj = {};
        let noteAttributes = {
          isGift: false,
        };
        if (e.target.checked) {
          noteAttributes = {
            isGift: true,
          };
        }
        cartObj["attributes"] = noteAttributes;
        fetch(`/cart/update.js`, {
          ...fetchConfig(),
          body: JSON.stringify(cartObj),
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            e.target
              .closest(".note-wrap")
              .querySelector("#addNodeBtn")
              .classList.toggle("d-none");
            e.target
              .closest(".note-wrap")
              .querySelector(".note-checker-icon")
              .classList.toggle("checked");
            if (
              !e.target
                .closest(".note-wrap")
                .querySelector(".note-checker-icon")
                .classList.contains("checked")
            ) {
              if (document.getElementById("cartPageNoteSubmit") != null) {
                document
                  .getElementById("cartPageNoteSubmit")
                  .classList.add("d-none");
                document.getElementById("checkout").classList.remove("d-none");
              }
            }
            if (document.querySelector(".cart__note--page")) {
              document
                .querySelector(".cart__note--page")
                .classList.add("is-hidden");
            }
          })
          .catch((error) => {
            this.querySelectorAll(".loading-overlay").forEach((overlay) =>
              overlay.classList.add("hidden")
            );
            document.getElementById("cart-errors").textContent =
              window.cartStrings.error;
            this.disableLoading();
          });
      });
    }
  }

  onChange(event) {
    if (
      !event.target.classList.contains("note-checker") &&
      event.target.closest("#cartnote") == null
    ) {
      if( event.target.closest("playbox-add-check") ) {

      } else {
        this.updateQuantity(
          event.target.dataset.index,
          event.target.value,
          document.activeElement.getAttribute("name")
        );
      }

    }
  }

  noteEvents() {
    this.addNodeBtn = document.getElementById("addNodeBtn");
    this.notePrint = document.getElementById("js-cartFooterNote");
    this.cartnote = document.getElementById("cartnote");
    this.noteChecker = document.getElementById("noteChecker");
    this.promoCode = document.getElementById("promoCode");
    this.closeNoteData = document.querySelectorAll(".close_note_js");
    this.cartPageNoteSubmit = document.getElementById("cartPageNoteSubmit");
    this.checkoutBtn = document.getElementById("checkout");
    this.openNote();
    this.closeNote();
  }

  openNote() {
    if (this.addNodeBtn != null) {
      this.addNodeBtn.addEventListener("click", (event) => {
        this.cartnote.classList.remove("is-hidden");
        if (this.cartPageNoteSubmit != null) {
          this.cartPageNoteSubmit.classList.remove("d-none");
          this.checkoutBtn.classList.add("d-none");
        }
        if (this.noteChecker) {
          this.noteChecker.classList.remove("icon-square");
        }
        if(this.addNodeBtn.classList.contains('guided_purchase-note')) {
          this.addNodeBtn.classList.add('d-none')
        }
        if (this.notePrint) {
          this.notePrint.classList.add("d-none");
        }
        // this.noteChecker.classList.add('icon-square-tick');
      });
    }
  }
  closeNote() {
    this.closeNoteData.forEach((element) => {
      element.removeEventListener("click", this.noteClosed);
      element.addEventListener("click", this.noteClosed);
    });
  }
  noteClosed() {
    document.getElementById("cartnote").classList.add("is-hidden");
    if (document.getElementById("addNodeBtn").classList.contains("guided_purchase-note")) {
      document.getElementById("addNodeBtn").classList.remove("d-none");
    }
    if (document.getElementById("js-cartFooterNote")) {
      document.getElementById("js-cartFooterNote").classList.remove("d-none");
    }
  }

  getSectionsToRender() {
    if (document.querySelector("#cart-wrapper__js") != null) {
      return [
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
        {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section",
        },
        {
          id: "cartHeadingNotice",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-content",
        },
        {
          id: "cart-count_js",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".c-cart-title-count",
        },
      ];
    } else if (document.querySelector("#cart-summary_js") != null) {
      return [
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section",
        },
        {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer").dataset.id,
          selector: ".js-price-content",
        },
        {
          id: "main-cart-footer-proxy",
          section: document.getElementById("main-cart-footer-proxy").dataset.id,
          selector: ".js-price-content",
        },
        {
          id: "cart-summary_js",
          section: document.getElementById("cart-summary_js").dataset.id,
          selector: ".summary-inline_recommendation",
        },
      ];
    } else {
      return [
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
        {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section",
        },
        {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer").dataset.id,
          selector: ".js-contents",
        },
        {
          id: "cart-recommendation__js",
          section: document.getElementById("cart-recommendation__js").dataset
            .id,
          selector: ".inline-recommendation",
        },
      ];
    }
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");
        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (document.querySelector("#cart-wrapper__js") != null) {
          const cartImage = document.getElementById("cartImage");
          const cardBody = this.querySelector("#cardBody");
          if (cartImage)
            cartImage.classList.toggle(
              "is-empty",
              parsedState.item_count === 0
            );
          if (cardBody)
            cardBody.classList.toggle("is-empty", parsedState.item_count === 0);
          setTimeout(() => {
            this.noteEvents();
            this.addNote();
          }, 1000);
          this.querySelector("#cart-wrapper__js").addEventListener(
            "change",
            this.debouncedOnChange.bind(this)
          );
        }

        const bestSellers = document.getElementById("cart-recommendation__js");
        if (bestSellers)
          bestSellers.classList.toggle("d-none", parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          if (section.selector == ".summary-inline_recommendation") {
            if (document.querySelector(".pdp_pww_block")) {
              document.querySelector(".popular-addon__js").style.display =
                "block";
            } else {
              document.querySelector(".popular-addon__js").style.display =
                "none";
            }
          }
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        if (document.querySelector("#cart-summary_js") != null) {
            const otherItems = document.querySelector(".other_items");
            const subscriptionCount= otherItems.querySelector(".summary__title").getAttribute('data-subs-count');
            const itemCount = parsedState.item_count - subscriptionCount;
            if(otherItems.querySelector(".js-contents").childNodes.length==0)
                otherItems.remove();
            else
                otherItems.querySelector(".summary__title h2").innerHTML = "Review other items in cart ("+itemCount+")";
        }
        this.disableLoading();
        this.bestSellerSwatches();
        this.bestSellerSlider();
        this.setBestSellersPriority();
        this.showBestSellers();
        if (document.querySelector("#cart-wrapper__js") != null) {
          this.updateCartHeight();
        }
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;
        this.disableLoading();
      });
  }

  addBestSeller(id, quantity) {
    // this.enableLoading(line);
    //sections: cart-notification-product,cart-notification-button,cart-icon-bubble,cart-drawer
    // sections_url: /products/the-chair
    const cartNotification = document.querySelector("cart-notification");
    const body = JSON.stringify({
      id,
      quantity,
      sections: cartNotification
        .getSectionsToRender()
        .map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        cartNotification.renderContents(response);
        // const parsedState = JSON.parse(state);
        // this.classList.toggle('is-empty', parsedState.item_count === 0);
        // const cartFooter = document.getElementById('main-cart-footer');
        // if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        // if(document.querySelector('#cart-wrapper__js') != null) {
        //   const cartImage = document.getElementById('cartImage');
        //   const cardBody = this.querySelector('#cardBody');
        //   if (cartImage) cartImage.classList.toggle('is-empty', parsedState.item_count === 0);
        //   if (cardBody) cardBody.classList.toggle('is-empty', parsedState.item_count === 0);
        //   this.noteEvents();
        this.addNote();
        //   this.querySelector('#cart-wrapper__js').addEventListener('change', this.debouncedOnChange.bind(this));
        // }
        // this.getSectionsToRender().forEach((section => {
        //   const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        //   elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        // }));
        // this.updateLiveRegions(line, parsedState.item_count);
        // const lineItem = document.getElementById(`CartItem-${line}`);
        // if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        // this.disableLoading();
        // this.updateCartHeight();
        // this.bestSeller();
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateCartHeight() {
    if (document.querySelector(".c-cart-top-content") != null) {
      const titleheight = document.querySelector(
        ".c-cart-top-content"
      ).offsetHeight;
      const footerheight = document.querySelector(
        ".c-cart-shipping__col "
      ).offsetHeight;
      const screenHeight = window.innerHeight;
      document
        .querySelector(".cart-you-may-like-wrap")
        .setAttribute(
          "style",
          `height:${screenHeight - titleheight - footerheight - 32}px`
        );
    }
  }

  bestSellerSwatches() {
    var colorSwatches = document.querySelectorAll(
      ".thumb-product-card__js .color-swatches a"
    );
    colorSwatches.forEach((swatch) => {
      swatch.addEventListener("click", (event) => {
        const currentTarget = event.currentTarget,
          clickedVariantId = currentTarget.getAttribute("data-variant-id"),
          parentDiv = currentTarget.closest(".thumb-product-card__js"),
          swatchesList = parentDiv.querySelectorAll(".swatch"),
          varitantImages = parentDiv.querySelectorAll(
            ".thumb-product-card-images img"
          ),
          salePrice = currentTarget.dataset.price,
          regularPrice = currentTarget.dataset.regularPrice;
        swatchesList.forEach((item) => {
          item.classList.remove("active");
        });

        parentDiv.querySelector(".price-item--sale").innerHTML = salePrice;
        parentDiv.querySelector(".price__sale .text-link s").innerHTML =
          regularPrice;

        currentTarget.parentNode.classList.add("active");
        varitantImages.forEach((image) => {
          const imageVariantId = image.getAttribute("data-variant-id");
          if (clickedVariantId === imageVariantId) {
            image.classList.add("show");
            image.classList.remove("d-none");
          } else {
            image.classList.add("d-none");
          }
        });
      });
    });
  }
  bestSellerSwatchesChange(event) {
    let currentTarget = event.currentTarget
      ? event.currentTarget
      : event.target;

    const clickedVariantId = currentTarget.value,
      parentDiv = currentTarget.closest(".thumb-product-card__js"),
      varitantImages = parentDiv.querySelectorAll(
        ".thumb-product-card-images img"
      ),
      salePrice =
        event.target.options[event.target.selectedIndex].dataset.price,
      regularPrice =
        event.target.options[event.target.selectedIndex].dataset.regularPrice;

    parentDiv.querySelector(".price-item--sale").innerHTML = salePrice;
    if(parentDiv.querySelector(".price__sale .text-link s") != null)
        parentDiv.querySelector(".price__sale .text-link s").innerHTML = regularPrice;

    varitantImages.forEach((image) => {
      const imageVariantId = image.getAttribute("data-variant-id");
      if (clickedVariantId === imageVariantId) {
        image.classList.add("show");
        image.classList.remove("d-none");
      } else {
        image.classList.add("d-none");
      }
    });
  }

  updateNotesEvent(skip = false) {
    var cartObj = {};
    var attributes = {
      sender_name: null,
      receiver_name: null,
      receiver_email: null,
      message: null,
      "item_[1]_name": null,
      "item_[0]_name": null,
      "item_[1]": null,
      "item_[0]": null,
      reciever_name: null,
      reciever_email: null,
      optional_message: null,
    };
    if (!skip) {
      const cartForm = document.getElementById("cart");
      const sender_name = document.getElementById("yourName").value;
      const receiver_name = document.getElementById("theirName").value;
      const receiver_email = document.getElementById("theirEmail").value;
      const optional_message = document.getElementById(
        "CartSpecialInstructions"
      ).value;
      attributes = {
        sender_name: `${sender_name}`,
        receiver_name: `${receiver_name}`,
        receiver_email: `${receiver_email}`,
        message: `${optional_message}`,
        "item_[1]_name": null,
        "item_[0]_name": null,
        "item_[1]": null,
        "item_[0]": null,
        reciever_name: null,
        reciever_email: null,
        optional_message: null,
      };
    }
    cartObj["attributes"] = attributes;

    fetch(`/cart/update.js`, {
      ...fetchConfig(),
      body: JSON.stringify(cartObj),
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {

        // const parsedState = JSON.parse(state);
        window.location.href = "/checkout";
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateNotes() {
    let cartPageNoteSubmit = document.getElementById("cartPageNoteSubmit");
    if (cartPageNoteSubmit != null) {
      cartPageNoteSubmit.addEventListener("click", () => {
        this.updateNotesEvent();
      });
    }

    let noteSubmit = document.getElementById("noteSubmit");
    if (noteSubmit != null) {
      noteSubmit.addEventListener("click", () => {
        this.updateNotesEvent();
      });
    }

    let skipNote = document.getElementById("skipNote");
    if (skipNote != null) {
      skipNote.addEventListener("click", () => {
        this.updateNotesEvent(true);
      });
    }

    if (this.CartSpecialInstructions != null) {
      this.CartSpecialInstructions.addEventListener("keyup", () => {
        this.cartNoteCharacterCount();
      });
    }
  }

  cartNoteCharacterCount() {
    if (document.getElementById("noteWordLimit") != null) {
      document.getElementById("noteWordLimit").querySelector("span").innerHTML =
        this.CartSpecialInstructions.value.length;
    }
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
        var liveRegions = document.getElementById(`Line-item-error-${line}`);
        if(liveRegions != null){
            liveRegions.querySelector(".cart-item__error-text").innerHTML =
            window.cartStrings.quantityError.replace(
            "[quantity]",
            document.getElementById(`Quantity-${line}`).value
            );
        }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
      const cartForm = document.getElementById("cart");
      cartForm.addEventListener("submit", () => {
        document
          .getElementById("drawer-loader")
          .classList.remove("is-hidden-loader__js");
      });
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const domPar = new DOMParser().parseFromString(html, "text/html");
    if(domPar.querySelector(selector) != null){
        return domPar
        .querySelector(selector).innerHTML;
    }
    else
        return "";
  }

  enableLoading(line) {
    document
      .getElementById("main-cart-items")
      .classList.add("cart__items--disabled");
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
      (overlay) => overlay.classList.remove("hidden")
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const disabledCartItems = document.getElementById("main-cart-items");
    if(disabledCartItems != null){
        disabledCartItems
        .classList.remove("cart__items--disabled");
    }
  }
}

customElements.define("cart-items", CartItems);

setTimeout(() => {
  if (document.querySelector(".c-cart-top-content")) {
    var titleheight = document.querySelector(
      ".c-cart-top-content"
    ).offsetHeight;
    var footerheight = document.querySelector(
      ".c-cart-shipping__col "
    ).offsetHeight;
    var screenHeight = window.innerHeight;
    document
      .querySelector(".cart-you-may-like-wrap")
      .setAttribute(
        "style",
        `height:${screenHeight - titleheight - footerheight - 32}px`
      );
  }
}, 1000);

class PlayboxCheckoutButton extends HTMLElement{

}

customElements.define('playbox-submit', PlayboxCheckoutButton)
